import { useContext } from "react";

import { useTranslation } from "react-i18next";

import DateTime from "components/DateTime";
import RegularHeader from "components/TableDetails/components/RegularHeader";
import TableContext from "context/table/tableContext";

const Header = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const { email, company, last_login } = detailsData;

    return (
        <RegularHeader
            titleValue={email}
            subtitleName={t(`Table##company`)}
            subtitleValue={company.name}
            additionalSubtitleName={t("Table##last sign in")}
            additionalSubtitleValue={<DateTime date={last_login} />}
        />
    );
};

export default Header;
